import type { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import { useTenantEntities } from '../../hooks/useTenantEntities';
import { EntityRefAutocomplete } from '../EntityRefAutocomplete';
import type {
  TenantPickerUiOptions,
  TenantPickerValue,
} from '../../schemas/tenantPickerSchema';

export const TenantPickerField = (
  props: FieldExtensionComponentProps<TenantPickerValue, TenantPickerUiOptions>,
) => {
  const { formData, onChange, schema, required, rawErrors, idSchema } = props;

  const { items, loading, error } = useTenantEntities();

  return (
    <EntityRefAutocomplete
      title={schema.title ?? 'Tenant'}
      description={schema.description}
      required={required}
      rawErrors={rawErrors}
      fieldId={idSchema?.$id}
      value={formData}
      onChange={onChange}
      items={items}
      loading={loading}
      error={error}
      loadingText="Loading tenants..."
      errorText="Unable to load Tenants from the Catalog."
    />
  );
};
